import { PermissionRequest } from "@p0security/shared/types/permission";
import { Typography } from "antd";
import { useMemo } from "react";

import { extractApproverName } from "../requestUtils";
import { PermissionPreview } from "./PermissionPreview";

export const RequestPreview: React.FC<{
  requestId: string;
  request: PermissionRequest;
}> = ({ requestId, request }) => {
  const requestVerbiage = useMemo(() => {
    const { agents, principal, requestor } = request;
    const agent = agents?.at(0);
    const suffix = agent ? (
      <>
        &nbsp;(via agent <Typography.Text strong>{agent}</Typography.Text>)
      </>
    ) : requestor !== principal ? (
      <>
        &nbsp;(on behalf of{" "}
        <Typography.Text strong>{principal}</Typography.Text>)
      </>
    ) : (
      <></>
    );
    return {
      requestor: (
        <>
          <Typography.Text strong>{requestor}</Typography.Text>
          {suffix}
        </>
      ),
      requestVerb: request.grantTimestamp ? "was granted" : "is requesting",
    };
  }, [request]);

  return (
    <PermissionPreview
      requestor={requestVerbiage.requestor}
      verb={requestVerbiage.requestVerb}
      permission={request}
      reason={request.reason}
      createdAt={request.approvalDetails?.approvedTimestamp}
      approverType={request.approvalDetails?.approvalSource}
      approverDetail={extractApproverName(request, true)}
      requestId={requestId}
    />
  );
};
